import { Button } from "alm-react-components";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { CardBox } from "../CardBox";

const FullScreenProgramCard = ({ cardInfo }: any) => {
  const navigate = useNavigate();
  return (
    <div className="w-[100%] mx-auto md:pb-8 md:pt-2 xl:px-32 lg:px-8 md:px-8 px-5">
      <div className="flex flex-wrap justify-between md:flex-nowrap">
        <div className="min-w-0 flex">
          <div>
            <h1 className="scroll-m-20 tracking-tight leading-7 text-2xl lg:text-3xl xl:text-4xl font-barlowLight font-light">
              <span
                className={`font-medium font-barlowMedium ${
                  cardInfo.quarter === cardInfo.currentQuarter
                    ? "text-primary"
                    : ""
                }`}
                dangerouslySetInnerHTML={{
                  __html: cardInfo?.quarter || "",
                }}
              />
              {` ${t("QuarterList.headingName")}`}
            </h1>

            <p className="mt-[1rem]"></p>
          </div>
        </div>
        <Button
          onClick={() => navigate("/home/quater-list")}
          variant="secondary"
          className="text-base font-normal px-6 py-1 h-9 dark:bg-fillMidGrayCard"
        >
          <span dangerouslySetInnerHTML={{ __html: t("Program.seeAll") }} />
        </Button>
      </div>
      <CardBox cardInfo={cardInfo} />
    </div>
  );
};
export default FullScreenProgramCard;
